import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import featuresStyle from "assets/jss/material-kit-react/views/landingPageSections/featuresStyle.jsx";

import features from "data/feature-cards.json";

class FeaturesSection extends React.Component {
  render() {
    const { classes } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );

    function InsertCardFooter({...props}){
      const {
        classes,
        feature
      } = props

      if (feature.footnotes) {
        return (
          <CardFooter className={classes.cardFooter}>
            {feature.footnotes.map((footnote) => (
              <p className={classes.footnote}>{footnote}</p>
            ))}
          </CardFooter>
        )
      }

      return null;
    }
    return (
      <div className={classes.section}>
        <GridContainer alignItems="center">
          <GridItem xs={12}>
            <h2 className={classes.title}>Key Features
            </h2>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer alignItems="stretch">
          {
            features.map(feature => (
            <GridItem xs={12} sm={6} md={4}>
              <Card raised className={classes.card}>
                <GridItem xs={4} md={6} className={classes.itemGrid}>
                  <div className={classes.avatar}>
                  <img className={imageClasses} src={require(`assets/img/${feature.img.src}`)} alt={feature.img.alt} />
                  </div>
                </GridItem>
                <h4 className={classes.cardTitle}>
                  {Array.isArray(feature.title) ? feature.title.join(" ") : feature.title}
                  <br />
                  <small className={classes.smallTitle}>{!Array.isArray(feature.subtitle) ? feature.subtitle : feature.subtitle.map((chunk) => (
                    <span>{chunk} </span>
                    ))}</small>
                </h4>
                <CardBody className={classes.cardBody}>
                { feature.text.map((line) => (
                  <p className={classes.description} dangerouslySetInnerHTML={{__html: `${line}`}}></p>
                  ))
                }
                </CardBody>
                <InsertCardFooter feature={feature} classes={classes}/>
              </Card>
            </GridItem>
          ))}
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(featuresStyle)(FeaturesSection);